import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import queryString from 'query-string';
import EditTenantInfoModal from './component';
import { getIreneDashboard, updateTenantInfo } from '@rental-manager/actions/requests';
import { closeNotification, showModalNotification, showPageNotification } from '@common/actions/NotificationActions';
import type { ErrorInterface } from '@common/types';
import { trackValidationError } from '@common/actions/TrackingActions';
import { TENANT_INFO_UPDATE_FAIL, TENANT_INFO_UPDATED } from '@rental-manager/constants/NotificationConstants';
import { checkRequestActionSuccess, getSignInPage } from '@common/paymentsUtils/api';
import HTTP_STATUS from '@common/constants/HttpConstants';
import { logError } from '@zg-rentals/log-error';

const mapStateToProps = (state, ownProps) => {
  const rentTermsKeyFromQueryString = queryString.parse(ownProps.location.search).rentTermsKey;
  const { currentTerm, nextTerm, selectedLease, userConfig } = state.payments.landlord.property;
  const { isRentGuaranteeEnabled } = userConfig;

  let rentTerm;
  if (rentTermsKeyFromQueryString && nextTerm?.rentTermsKey === rentTermsKeyFromQueryString) {
    rentTerm = nextTerm;
  } else if (rentTermsKeyFromQueryString && currentTerm?.rentTermsKey === rentTermsKeyFromQueryString) {
    rentTerm = currentTerm;
  }

  const { tenantFirstName, tenantLastName, tenantEmail, rentTermsKey } = rentTerm;

  const selectedTenantId = selectedLease?.leaseTenants?.findIndex(
    (leaseTenant) =>
      leaseTenant.firstName === tenantFirstName &&
      leaseTenant.lastName === tenantLastName &&
      leaseTenant.email === tenantEmail,
  );
  return {
    landlordEmail: state.user.email,
    tenantFirstName,
    tenantLastName,
    tenantEmail,
    rentTermsKey,
    selectedLease,
    isRentGuaranteeEnabled,
    selectedTenantId,
  };
};

const mapDispatchToProps = (dispatch, { baseUrl, propertyId }) => ({
  onSubmit: async ({ tenantFirstName, tenantLastName, emailAddress, rentTermsKey }) => {
    try {
      // Close any open banners
      await dispatch(closeNotification());

      // Request to update the tenant info
      const updateTenantInfoResponse = await dispatch(
        updateTenantInfo({
          propertyId,
          rentTermsKey,
          tenantInfo: {
            firstName: tenantFirstName,
            lastName: tenantLastName,
            email: emailAddress,
          },
        }),
      );
      await checkRequestActionSuccess(updateTenantInfoResponse);

      // Request the latest landlord status
      const [landlordStatusResponse] = await dispatch(getIreneDashboard({ propertyId }));
      await checkRequestActionSuccess(landlordStatusResponse);

      // Navigate to dashboard
      await dispatch(push(baseUrl));

      // Show a success banner
      await dispatch(showPageNotification(TENANT_INFO_UPDATED));

      return { error: false };
    } catch (err) {
      const error = err as ErrorInterface;
      if (error.action && error.action.payload) {
        const { status } = error.action.payload;

        // If 401 status, redirect to sign-in
        if (status === HTTP_STATUS.SC_UNAUTHORIZED) {
          window.location = getSignInPage();
          return null;
        }
      }

      logError({ error: err });
      dispatch(showModalNotification(TENANT_INFO_UPDATE_FAIL));
      return { error: true };
    }
  },
  onClose: async () => {
    await dispatch(closeNotification());
    await dispatch(push(baseUrl));
  },
  onCancel: async () => {
    await dispatch(closeNotification());
    await dispatch(push(baseUrl));
  },
  trackValidationError: (data) => dispatch(trackValidationError(data)),
});

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  onSubmit: (tenantInvitationInfo) => dispatchProps.onSubmit(tenantInvitationInfo, stateProps.editMode),
  onClose: () => dispatchProps.onClose(stateProps.editMode),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(EditTenantInfoModal);
